export default {
  All: 'statuses.All',
  Processing: 'statuses.Processing',
  Completed: 'statuses.Completed',
  Exception: 'statuses.Exception',
  OnHold: 'statuses.OnHold',
  Cancelled: 'statuses.Cancelled',
  CleanSweeped: 'statuses.CleanSweeped',
  ImportReview: 'statuses.ImportReview'
}
